// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 4C1 2.34315 2.34315 1 4 1C5.30622 1 6.41746 1.83481 6.82929 3H17.1707C17.5825 1.83481 18.6938 1 20 1C21.6569 1 23 2.34315 23 4C23 5.30622 22.1652 6.41746 21 6.82929V17.1707C22.1652 17.5825 23 18.6938 23 20C23 21.6569 21.6569 23 20 23C18.6938 23 17.5825 22.1652 17.1707 21H6.82929C6.41746 22.1652 5.30622 23 4 23C2.34315 23 1 21.6569 1 20C1 18.6938 1.83481 17.5825 3 17.1707V6.82929C1.83481 6.41746 1 5.30622 1 4ZM5 6.82929V17.1707C5.85241 17.472 6.52801 18.1476 6.82929 19H17.1707C17.472 18.1476 18.1476 17.472 19 17.1707V6.82929C18.1476 6.52801 17.472 5.85241 17.1707 5H6.82929C6.52801 5.85241 5.85241 6.52801 5 6.82929Z"}}]};

const TransformFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'transform-filled',
    ref,
    icon: element,
  },
));

TransformFilledIcon.displayName = 'TransformFilledIcon';

export default TransformFilledIcon;
